import React from "react";
import { kinetik_api_url,mapDbClaimsToTableRow,toggleStyle } from "~/app/utilities";
import axios from "axios";
import _ from "underscore";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addViewClaims, isRecentBatch } from "../upload/actions";
import { updateSelBatchClaims } from "./actions";
import FontAwesome from "react-fontawesome";
import DatePicker from "react-datepicker";
import moment from "moment";

class RecentBatch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      batches: [],
      selectedDate: null,
    };
  }

  getRecentBatches=()=>{
    if(this.props.provider_info===null) return -1;
    const bill_npi = this.props.provider_info.company_billing_npi
    const token = localStorage.getItem('authToken');

    axios
    .get(kinetik_api_url + "/batch/recent/"+bill_npi+"?token="+token)
    .then(response => {
      this.setState({ batches: response.data });
    })
    .catch(err => {
      console.log("/batch error:", err);
    });
  }

  componentDidUpdate=(prevProps)=>{
    if(this.props.view_claims!==prevProps.view_claims || this.props.provider_info!==prevProps.provider_info){
      this.getRecentBatches();
    }
  }
  componentDidMount=()=>{
    this.getRecentBatches();
  }

  handleDateChange = date => {
    const bill_npi = this.props.provider_info.company_billing_npi;
    const token = localStorage.getItem('authToken');
    this.setState({ selectedDate: date })   
    axios
    .post(kinetik_api_url + "/batch/bydate",{date,bill_npi,token})
    .then(response => {
      this.setState({batches:response.data})
    })
    .catch(err => {
      console.log("/file/:date error:", err);
    });
  };
  


  viewTable = selectedIndex => {
    const batch = this.state.batches[selectedIndex];
    const token = localStorage.getItem('authToken');
    axios
      .post(kinetik_api_url + "/batch/claims", {
        claim_ids: batch.claims, token
      })
      .then(response => {
        const mappedData = _.map(response.data, mapDbClaimsToTableRow);
        const errorIndexes=[] 
            _.each(mappedData, claim =>{  // to remove "ins_" errors 
            if(claim.error!==null){
              _.each(claim.error, (error,index) =>{
                if (error._attributes.fields.substring(0,3)===("ins")){
                  errorIndexes.push(index);
                }
              })
              _.each(errorIndexes,index=>{
               claim.error.splice(index,1);
             })
            }
              
            })

        this.props.updateSelBatchClaims(response.data);
        this.props.addViewClaims(mappedData);
        this.props.isRecentBatch(true);
      })
      .catch(err => {
        console.log("/batch/claims error:", err);
      });
  };
  renderBatches = batches => {
    //console.log("batches",batches);
    if (batches.length !== 0) {
      return _.map(batches, (batch, index) => {
        const grey = toggleStyle(index);
        return (
          <div className={"recent-batch " + grey} key={index}>
            <FontAwesome
              className="icon-eye"
              name="eye"
              onClick={() => this.viewTable(index)}
            />
            <span className="batch-name">{batch.file_name}</span>
            <span className="batch-date">
              {moment(batch.last_updated.toString().substring(0, 10)).format('l') }
            </span>
            <span className="batch-number">{batch.claims.length}</span>
          </div>
        );
      });
    } else {
      return (
        <div className="recent-batch">
          <p className="center-text"> You have no recent batch submissions!</p>
        </div>
      );
    }
  };

  render = () => {
    const highlightToggle= this.props.is_recent_batch;

    return (
      <div className={this.highlightBox(highlightToggle)}>
        <div className="box-header">
          <div className="header-name">Recent Files</div>
         {/* <DatePicker 
            className="datepicker-input"
            selected={this.state.selectedDate}
            onChange={this.handleDateChange}
          />
                
                    <FontAwesome className="icon-cal" name="calendar" /> */}
        <div className="input-group right-no-margin">
          <span className="input-group-addon">
              <FontAwesome className="icon" name="calendar" />
          </span>
          <DatePicker
            className="datepicker-input"
            selected={this.state.selectedDate}
            onChange={this.handleDateChange}
          />
        </div>

        </div>
        <div className="box-content ">
          <div className="batch-header">
            <span className="batch-name-header">File Name</span>
            <span className="batch-date-header">Submission Date</span>
            <span className=""># of Claims</span>
          </div>
          <div className="uploaded-files-content">
          {this.renderBatches(this.state.batches)}
          </div>
        </div>
      </div>
    );
  };

  highlightBox = (highlightToggle) => {
    if (highlightToggle) { return "small-box left box-highlight" }
    else {
      return "small-box left"
    }
  }
}

const mapStateToProps = state => {
  return {
    view_claims: state.submitClaims.view_claims,
    is_recent_batch: state.submitClaims.is_recent_batch,
    provider_info: state.userData.provider_info

  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addViewClaims: addViewClaims,
      isRecentBatch:isRecentBatch,
      updateSelBatchClaims: updateSelBatchClaims
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RecentBatch);




// WEBPACK FOOTER //
// ./src/app/submit_claims/recent_batch/RecentBatch.js